
import { defineComponent, inject, ref, reactive, computed } from 'vue'
import type { FormInstance, FormRules } from "element-plus";
import { useStore } from "vuex";

import clubService from "@/core/services/InstitutionService"
import { errManager } from "@/core/config/Tools";

export default defineComponent({
    props: {
        setting: {
            type: Object,
            required: true,
            default: {}
        },
        item: {
            type: Object,
            required: false,
            default: {}
        }
    },
    setup(props, { emit }) {
        const store = useStore();
        const titleDialog = ref('')
        const gblDialog = inject<any>('gblDialog')
        const gblAction = inject<any>('gblAction')

        const loader = ref(false)
        const ruleFormRef = ref<FormInstance>()
        const listCategorie = ref<any>([])
        const listTypes = ref<any>([])
        const listStatus = ref<any>([])
        const form = reactive<any>({})
        const rules = reactive<FormRules>({
            ruc: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            business: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            abrev: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            category: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            instype: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            country: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            idseat: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
            mstatus: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }],
        })

        const listRegions: any = computed<any>(() => {
            return store.getters.currentUser.regions;
        });

        const listCountry: any = computed<any>(() => {
            return store.getters.currentUser.country;
        });

        const onOpen = () => {
            titleDialog.value = gblAction.value == 'new' ? 'Registrar institución' : 'Editar institución'
            listTypes.value = props.setting.types
            listCategorie.value = props.setting.categories
            listStatus.value = props.setting.status
        }

        const onOpened = () => {
            if (gblAction.value == 'edit')
                onEdit()
        }

        const onClosed = () => {
            titleDialog.value = ''
            resetForm(ruleFormRef.value)
            Object.keys(form).forEach(key => delete form[key]);
        }

        const resetForm = (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            formEl.resetFields();
        };

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            await formEl.validate((valid, fields) => {
                if (valid)
                    (gblAction.value == 'new') ? save() : update()

            });
        };

        const onEdit = async () => {
            loader.value = true
            await clubService.edit(props.item.idinstitution)
                .then((res) => {
                    loader.value = false
                    Object.assign(form, res.data)
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const save = () => {
            loader.value = true
            clubService.save(form)
                .then((res) => {
                    loader.value = false
                    emit("onResponse", res.data)
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const update = () => {
            loader.value = true
            clubService.update(form.idinstitution, form)
                .then((res) => {
                    loader.value = false
                    emit("onResponse", res.data)
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        return {
            gblDialog,
            gblAction,
            titleDialog,
            ruleFormRef,
            loader,
            form,
            rules,
            listCategorie,
            listTypes,
            listRegions,
            listCountry,
            listStatus,
            //event
            onOpen,
            onOpened,
            onClosed,
            onEdit,
            resetForm,
            submitForm,

        }

    },
})
